import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

export const FooterContainer = styled.div`
  padding: 0.5rem;
  text-align: center;
  position: relative;
`;

export const FooterText = styled.div`
  font-size: ${({ theme }) => theme.font.size.default};
  color: ${({ theme }) => (theme as IOcAppTheme).color.footerText || theme.color.betaBadge};
  position: relative;
  z-index: 1;
`;